// @flow

import { type IncomingPayment } from './types';

export function getAmountUsd(incomingPayment: IncomingPayment): number {
  if (incomingPayment.v2 && incomingPayment.v2.amount)
    return incomingPayment.v2.amount.usd;

  return incomingPayment['amount_usd'];
}
